<!--
    @修改人：黎柏祺
    @修改时间：2018-11-28
    @修改描述：框架升级
    @版本:v1.0.26
    ------------
    @负责人: 谢汉
    @创建时间: 2018-01-18
    @版本:v1.0.12
    @描述: 用户分布页
    -->
<template>
  <div class="userDistribution__content">
    <div class="userDistribution__chart" id="userDistributionId">
      <full-screen :wrapperId="wrapperId" @get="getScreen"></full-screen>
      <chart-base  
        ref="userDistribution" 
        chart-id="userDistribution__chart" 
        :chart-data="chartData" 
        :chart-style="chartStyle"
        type="BAR">
      </chart-base>
      <div class="headerBox" v-text="time"></div>
      <div class="descBox">
        <p v-for="(item,index) in userInfoList" :key="index">
          <span v-text="item.info"></span>:
          <span v-text="item.num"></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import UserDistributionBiz from '@/logic/systemDiagram/userDistributionBiz'
import eventCenter from '@/utils/eventCenter'
import TimeFormat from '@/utils/timeFormat.js'
import ChartHelper from '@/logic/components/chartBiz.js'
import fullScreen from '../component/userDistribution/fullScreen.vue'
import chartBase from '@/components/chart/chart-base.vue'
const eventBind = eventCenter()
let appChartHelper = new ChartHelper()
const CHECK_INTERVAL = 60 * 1000
//    const CHECK_INTERVAL_30 = 180 * 1000;

const CHECK_INTERVAL_LIST = {}
CHECK_INTERVAL_LIST[CHECK_INTERVAL] = '1min'
//    CHECK_INTERVAL_LIST[CHECK_INTERVAL_30] = '3min';
export default {
  data () {
    return {
      wrapperId: 'userDistributionId',
      refreshText: '',
      timer: null,
      interval: CHECK_INTERVAL,
      intervalList: CHECK_INTERVAL_LIST,
      noData: false,
      userInfoList: [
        { info: '', num: '' },
        { info: '', num: '' },
        { info: '', num: '' },
        { info: '', num: '' },
        { info: '', num: '' },
        { info: '', num: '' }
      ],
      timeOff: '',
      time: '',
      clockTimer: null,
      chartData: {},
      chartStyle: {}
    }
  },
  methods: {
    init () {
      // 查询状态
      this.startClock()
      this.clearTimer()
      this.startTimer()
    },
    getData () {
      const that = this
      UserDistributionBiz.getUserData().then(function (data) {
        if (data.tmlCountryList.length > 0) {
          const chartData = appChartHelper.converUserDistribution(data)
          that.userInfoList.map((item, index) => {
            item.num = chartData.Allcount[index]
          })
          that.chartData = {
            rows: data.tmlCountryList,
            columns: ['iso', 'count'],
            colors: ['#3398DB'],
            seriesStyle: {
              barMaxWidth: 50
            }
          }
        } else {
          that.noData = true
        }
      })
    },
    e_stopTimer () {
      if (this.timer) {
        this.refreshText = this.$t('userDistribution.start')
        this.clearTimer()
      } else {
        this.refreshText = this.$t('userDistribution.stop')
        this.startTimer()
      }
    },
    e_intervalChange (name, index) {
      this.interval = index
      this.clearTimer()
      this.startTimer()
    },
    clearTimer () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    startTimer () {
      this.getData()
      this.timer = setInterval(this.getData, this.interval)
    },
    startClock () {
      this.time = 'GMT0 ' + TimeFormat.convertDatetime(new Date())
      this.clockTimer = setInterval(() => {
        this.time = 'GMT0 ' + TimeFormat.convertDatetime(new Date())
      }, 1000)
    },
    clearClock () {
      if (this.clockTimer) {
        clearInterval(this.clockTimer)
        this.clockTimer = null
      }
    },
    getScreen (...data) {
      document.getElementById('userDistributionId').style.height = data[1] + 'px'
    }
  },
  components: {
    chartBase,
    fullScreen
  },
  mounted () {
    this.chartStyle = {
      xAxis: {
        axisLabel: {
          interval: 0,
          rotate: 60
        },
        boundaryGap: ['20%', '20%'],
        axisTick: {
          alignWithLabel: true
        }
      },
      grid: {
        left: '5%',
        right: '5%'
      }
    }
    this.refreshText = this.$t('userDistribution.stop')
    this.userInfoList[0].info = this.$t('userDistribution.userCount')
    this.userInfoList[1].info = this.$t('userDistribution.tmlCountryCount')
    this.userInfoList[2].info = this.$t('userDistribution.userMax')
    this.userInfoList[3].info = this.$t('userDistribution.hisOnlineCountryMax')
    this.userInfoList[4].info = this.$t('userDistribution.todayOnlineTmlMax')
    this.userInfoList[5].info = this.$t('userDistribution.todayLoginTmlCount')
    this.init()
  },
  watch: {
    '$route' (newVal, oldVal) {
      if (newVal.name === 'userDistribution') {
        this.init()
      } else {
        this.clearTimer()
        this.clearClock()
        eventBind.removeResizeEvent('userDistribution')
      }
    }
  },
  destroyed () {
    this.clearTimer()
    this.clearClock()
    eventBind.removeResizeEvent('userDistribution')
  }
}
</script>
<style>
  .userDistribution__content .userDistribution__chart {
    position: relative;
    width: 100%;
    height: 600px;
    margin: 0 auto;
  }
  .userDistribution__content .rct-select {
    min-width: 80px;
  }
  .userDistribution__content .headerBox {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    background: #609fff;
    padding: 4px;
    color: #fff;
    border-radius: 2px;
    font-weight: bold;
    font-size: 14px;
  }
  .userDistribution__content .descBox {
    position: absolute;
    top: 60px;
    right: 5%;
    z-index: 10;
    border: 1px #4c4c4c solid;
    border-radius: 2px;
    padding: 10px 12px;
    background: #ececec;
    font-size: 14px;
  }
  .userDistribution__content .descBox p {
    margin-bottom: 0;
    line-height: 24px;
    font-weight: bold;
  }
</style>